<template>
  <div>
    <div class="sub_visual_wrap">
        <div class="sub_visual_box container">
            <div class="page_nav">
                <ul>
                    <li><router-link to="/main" @click.native="$store.commit('setActive','')">{{$t('common.home')}}</router-link></li>
                    <li><a href="#">{{$t('common.privacyPolice')}}</a></li>
                </ul>
            </div>	
            <h2>{{$t('common.privacyPolice')}}</h2>
        </div>
    </div>
    <section class="container">
        <div class="sub_contents_wrap">
            <div class="term_wrap" v-if="this.$i18n.locale == 'Korean'">
                <p>HD현대 인프라코어 주식회사(이하 ‘회사”라고 함)는 개인정보보호법, 정보통신망 이용촉진 및 정보보호에 관한 법률 등 관련 법령상의 개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 고객, 임직원, 홈페이지 이용자 등 정보주체의 권익 보호에 최선을 다하고 있습니다.</p>
                <p>회사는 개인정보처리방침 등을 통하여 정보주체가 제공하는 개인정보가 어떠한 용도와 방식으로 처리되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려 드립니다. 회사는 개인정보처리방침 등을 개정하는 경우 회사 웹사이트 공지사항(또는 개별공지)을 통해 공지할 것 입니다.</p>
                <p>현행 시행일자 : 2020년 9월 1일</p>
                <div class="term_box">
                    <div class="term_title">01. 총칙</div>
                    <p>“개인정보”란 살아 있는 개인에 관한 정보로서 성명, 주민등록번호 및 영상 등을 통하여 개인을 알아볼 수 있는 정보(해당 정보만으로는 특정개인을 알아볼 수 없더라도 다른 정보와 쉽게 결합하여 알아볼 수 있는 것을 포함한다)를 말합니다. ‘정보주체”란 처리되는 정보에 의하여 알아볼 수 있는 사람으로서 그 정보의 주체가 되는 사람을 말합니다. 회사는 <b>개인정보처리방침</b>을 홈페이지(<a href="https://gsis.hd-infracore.com" target="_blank">gsis.hd-infracore.com</a>) 첫 화면에 공개함으로써 언제나 쉽게 확인할 수 있도록 조치하고 있습니다.</p>
                </div>
                <div class="term_box">
                    <div class="term_title">02. 개인정보의 처리 목적</div>
                    <p>회사는 다음과 같은 목적을 위해 개인정보를 처리합니다.</p>
                    <div class="trem_under_t">
                        <h4>[회사 제공 서비스 관련]</h4>
                        <p></p>
                        <ul>
                        <li>회원 관리, 불만처리 등 민원처리</li>
                        <li>온라인 시장조사 또는 여론 조사</li>
                        <li>마케팅 또는 광고</li>
                        <li>서비스 제공 및 요금정산</li>
                        <li>협력업체 지원 서비스</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[채용 관련]</h4>
                        <p></p>
                        <ul>
                        <li>입사전형 진행, 입사지원서 수정, 합격여부 확인, 입사지원자와의 연락, 채용자격 요건 확인</li>
                        <li>급여 지급, 복리후생 제공, 각종 업무수행 지원 및 평가 등 인사관리</li>
                        </ul>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">03. 개인정보의 처리 및 보유 기간</div>
                    <p>원칙적으로, 개인정보의 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 다만, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 처리 및 보유합니다.</p>
                    <div class="trem_under_t">
                        <h4>[회사 제공 서비스 관련]</h4>
                        <ul>
                        <li>항목 : 성명, 자택 주소, 이메일, 연락처, 회사명, 대표자명, 업종, 계좌정보, 서비스 이용기록, 접속 로그, 쿠키, 접속 IP정보</li>
                        <li>기간 : 지원 서비스 종료 시까지 보유. 다만, 법령에 특별한 규정이 있을 경우 관계 법령에 따라 보관</li>
                        <li>이유 : 사용자 식별, 서비스의 질 향상 및 협력업체 업무 지원</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[채용/채용유지 관련]</h4>
                        <ul>
                        <li>항목 : 성명, 비밀번호, 생년월일, 성별, 주민등록번호, 자택 주소, 자택 전화번호, 휴대전화 번호, 취미, 특기, 학력, 경력, 어학 능력, 병역사항, 가족사항</li>
                        <li>기간 : 근로관계 종료시까지 보유. 다만, 동의를 받은경우 보유기간을 연장 할 수 있습니다.</li>
                        <li>이유 : 급여 지급, 복리후생 제공, 각종 업무수행 지원 및 평가 등 인사관리</li>
                        </ul>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">04. 개인정보의 파기 방법</div>
                    <p>회사는 개인정보의 처리목적 달성, 해당 서비스의 폐지, 사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보를 파기합니다.</p>
                    <div class="trem_under_t">
                        <div class="t_u_inner">
                            <h5>1. 파기 절차</h5>
                            <p>불필요한 개인정보 및 개인정보파일은 내부방침 및 절차에 따라 다음과 같이 처리하고 있습니다.</p>
                            <ul>
                                <li>개인정보의 파기 : 보유기간이 경과한 개인정보는 종료일로부터 지체 없이 파기합니다.</li>
                                <li>개인정보 파일의 파기 : 개인정보파일의 처리 목적 달성, 해당 서비스의 폐지 등 개인정보파일이 불필요하게 되었을 때에는 개인정보의 처리가 불필요한 것으로 인정되는 날로부터 지체 없이 그 개인정보파일을 파기합니다.</li>
                            </ul>
                        </div>
                        <div class="t_u_inner">
                            <h5>2. 파기 방법</h5>
                            <ul>
                                <li>전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.</li>
                                <li>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
                            </ul>
                        </div>                        
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">05. 개인정보의 제3자 제공</div>
                    <p>회사는 관련법령, 정보주체의 사전 동의 등 정당한 사유 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</p>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>정보주체로부터 별도의 동의를 받는 경우</li>
                        <li>다른 법률에 특별한 규정이 있는 경우</li>
                        <li>정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나 주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우</li>
                        <li>통계작성 및 학술연구 등의 목적을 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 개인정보를 제공하는 경우</li>
                        </ul>
                    </div>
                    <p>현재 회사는 아래와 같이 개인정보를 제공하고 있습니다.</p>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>개인정보를 제공 받는 자 : ㈜멀티캠퍼스, 한국토익위원회, 대한상공회의소</li>
                        <li>제공하는 개인정보의 항목 : 성명, 생년월일, 휴대전화번호</li>
                        <li>제공정보의 이용 목적 : 채용시 자격 검증</li>
                        <li>제공정보의 보유 및 이용 기간 : 자격 검증시 까지</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>개인정보를 제공 받는 자 : 국방부/지방병무청, 구청/동주민센터</li>
                        <li>제공하는 개인정보의 항목 : 성명, 주민등록번호, 휴대전화번호, 군번</li>
                        <li>제공정보의 이용 목적 : 예비군 편성, 동원, 훈련, 해체 등 예비군 관련 사무의 수행</li>
                        <li>제공정보의 보유 및 이용 기간 : 근로관계 종료시까지</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>개인정보를 제공 받는 자 : (주)HD현대 인프라코어</li>
                        <li>제공하는 개인정보의 항목 : 성명, 사진, 비밀번호, 자택 주소, 자택 전화번호, 휴대전화 번호, 이메일, 학력, 병역, 어학 능력, 컴퓨터 능력, 자격사항, 가족관계, 경력, 사회경험, 수상경험, 해외경험, 연구경험</li>
                        <li>제공정보의 이용 목적 : 채용된 인적자원의 통합관리 및 개발</li>
                        <li>제공정보의 보유 및 이용 기간 : 근로관계 종료시까지</li>
                        </ul>
                    </div>

                </div>
                <div class="term_box">
                    <div class="term_title">06. 개인정보처리의 위탁</div>
                    <p>회사는 정보주체의 동의 없이 개인정보의 처리를 외부 업체에 위탁하지 않습니다. 회사는 아래와 같이 개인정보의 처리를 위탁하고 있으며, 관련 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.</p>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>수탁업체 : 현대C&R</li>
                        <li>위탁업무 내용 : 급여관리, 복리후생, 총무(업무용 차량∙휴대폰 관리, 상조 등) 업무위탁</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>수탁업체 : (주)멀티캠퍼스, 고려아카데미, 알파코, 스피쿠스, 피커폰, e캠퍼스, KT Innoedu</li>
                        <li>위탁업무 내용 : 임직원 인터넷 강의 업무 등</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>수탁업체 : (주)HD현대 인프라코어 디지털이노베이션</li>
                        <li>위탁업무 내용 : 인사정보처리시스템 운영 및 관리(유지보수) 위탁</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>수탁업체 : 인터내셔널에스오에스코리아(주)</li>
                        <li>위탁업무 내용 : 임직원 해외출장 정보 연동 통한 위치파악시스템 운영</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>수탁업체 : (주)에스원</li>
                        <li>위탁업무 내용 : 사진촬영, 출입카드제작/발급 총괄</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>수탁업체 : 금아데이타테크(주)</li>
                        <li>위탁업무 내용 : 사원증 카드 제작/발급</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>수탁업체 : Photomind</li>
                        <li>위탁업무 내용 : 임직원 사진촬영</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>수탁업체 : Oracle Corporation</li>
                        <li>위탁업무 내용 : 개인정보 보관 및 관리</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>수탁업체 : Salesforce.com Singapore Pte Ltd</li>
                        <li>위탁업무 내용 : 개인정보 보관 및 관리</li>
                        </ul>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">07. 정보주체의 권리의무 및 그 행사방법</div>
                    <p>모든 정보주체는 회사가 처리하는 자신의 개인정보에 대한 열람, 정정∙삭제 및 처리정지를 요구할 수 있습니다. 다만, 아래 사항에 해당하는 경우 회사는 위와 같은 요구를 거절하거나 제한할 수 있습니다.</p>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</li>
                        <li>다른 사람의 생명∙신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</li>
                        <li>개인정보를 처리하지 아니하면 정보주체와 약정한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한 경우로서 정보주체가 그 계약의 해지 의사를 명확하게 밝히지 아니한 경우</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>권리행사 방법 및 절차</h4>
                        <ul>
                        <li>개인정보의 열람 등을 원하는 정보주체는 열람∙정정∙삭제∙처리정지 청구서를 서면, 전자우편, 팩스 등의 방법으로 개인정보 담당부서에 제출하실 수 있습니다. (담당부서는 ‘08. 개인정보에 민원 서비스” 참조)</li>
                        <li>회사는 정당한 사유가 없는 한 10일 이내에 해당 조치를 취하고, 거절 또는 제한의 사유가 있는 경우에는 5일 이내에 제한∙거절의 사유 및 이의 제기 방법을 알려드립니다.</li>
                        <li>회사는 정보주체 또는 그의 대리인이 개인정보의 열람 등을 청구하는 때에는 주민등록증 등의 신분증명서, 공인전자서명 등을 확인하여 정보주체 본인 또는 대리인 여부를 확인할 수 있습니다.</li>
                        </ul>
                    </div>                    
                </div>
                <div class="term_box">
                    <div class="term_title">08. 개인정보에 관한 민원 서비스</div>
                    <p>회사는 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보 보호책임자를 지정하고 있습니다.</p>
                    <div class="trem_under_t">
                        <div class="t_u_inner">
                            <h5>1. 개인정보 담당부서</h5>
                            <p></p>
                            <ul>
                                <li>부서 : 정보보안팀</li>
                                <li>전화번호 : 031-5179-4146, 4144</li>
                                <li>팩스번호 : 031-5179-4198</li>
                                <li>이메일 : <a href="mailto:di_security@hyundai-di.com">di_security@hyundai-di.com</a></li>
                                <li>업무시간 안내 : (월~금) 09:00 – 18:00, (공휴일, 토~일) 휴무</li>
                            </ul>
                        </div>
                        <div class="t_u_inner">
                            <h5>2. 개인정보 보호책임자</h5>
                            <p></p>
                            <ul>
                                <li>이름 : 박동범 상무</li>
                                <li>전화번호 : 031-5179-4146</li>
                                <li>이메일 : <a href="mailto:di_security@hyundai-di.com">di_security@hyundai-di.com</a></li>
                            </ul>
                        </div> 
                        <div class="t_u_inner">
                            <h5>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</h5>
                            <p></p>
                            <ul>
                                <li>개인분쟁조정위원회 (<a href="http://privacy.kisa.or.kr" target="_blank">http://privacy.kisa.or.kr</a> 전화번호: 118)</li>
                                <li>개인정보침해신고센터 (<a href="http://www.privacy.go.kr" target="_blank">http://www.privacy.go.kr</a> 전화번호: 118)</li>
                                <li>정보보호마크인증위원회 (<a href="http://www.eprivacy.or.kr" target="_blank">http://www.eprivacy.or.kr</a> 전화번호: 02-580-0533~4)</li>
                                <li>대검찰청 인터넷범죄수사센터 (<a href="http://www.spo.go.kr" target="_blank">http://www.spo.go.kr</a> 전화번호: 02-3480-3600)</li>
                                <li>경찰청 사이버테러대응센터 (<a href="http://www.ctrc.go.kr" target="_blank">http://www.ctrc.go.kr</a> 전화번호: 02-392-0330)</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">09. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</div>
                    <p>회사는 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다. 회사는 다음과 같은 목적을 위해 쿠키를 사용합니다.</p>
                    <div class="trem_under_t">
                        <div class="t_u_inner">
                            <h5>1. 쿠키 등 사용 목적</h5>
                            <p>이용자의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공 귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 귀하는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</p>
                        </div>
                        <div class="t_u_inner">
                            <h5>2. 쿠키 설정 거부 방법</h5>
                            <p>
                            예: 쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. 설정방법 예(인터넷 익스플로어의 경우) : 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보
                            <br>단, 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.
                            </p>
                        </div>                        
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">10. 개인정보의 국외이전</div>
                    <p>회사는 아래 시스템을 통한 업무처리 과정에서 다음과 같이 국외의 제3자에게 개인정보를 이전하고 있으며, 정보주체가 거주하는 국가 이외의 지역에 있는 서버에서 정보주체의 개인정보를 처리할 수 있습니다.</p>
                    <div class="trem_under_t">
                        <h4>[Access Portal]</h4>
                        <p></p>
                        <ul>
                        <li>
                        이전받는 업체 및 연락처
                        <br>업체명 : Oracle Corporation
                        <br>연락처 : <a href="https://www.oracle.com/corporate/contact/" target="_blank">https://www.oracle.com/corporate/contact/</a> (전화번호: +1.650.506.7000)
                        </li>
                        <li>
                        이전되는 국가, 일시 및 방법
                        <br>이전국가 : 미국, Virginia주, Ashburn
                        <br>일시 및 방법 : Access Protal을 통해 계정 발급 요청시점에 네트워크를 통한 전송
                        </li>
                        <li>
                        이전되는 개인정보 항목
                        <br>이용자의 이름, User ID, 국적, 이메일, 전화번호, 휴대전화 번호, 직급
                        </li>
                        <li>
                        개인정보를 이전받는 자의 이용목적 및 보유∙이용 기간
                        <br>개인정보 보유기간 동안 개인정보를 이전받는 자가 운영하는 해외 데이터 센터에 개인정보를 저장, 보관, 관리
                        </li>
                        <li>
                        동의를 거부할 권리 및 동의 거부에 따른 불이익
                        <br>정보주체는 정보 수집을 거부할 권리가 있습니다. 단, 동의를 거부할 경우 서비스가 제한될 수 있습니다.
                        </li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[CRM]</h4>
                        <p></p>
                        <ul>
                        <li>
                        이전받는 업체 및 연락처
                        <br>업체명 : Salesforce.com Singapore Pte Ltd
                        <br>연락처 : <a href="https://www.salesforce.com/form/other/privacy-request" target="_blank">https://www.salesforce.com/form/other/privacy-request</a>
                        </li>
                        <li>
                        이전되는 국가, 일시 및 방법
                        <br>이전국가 : 일본, Tokyo
                        <br>일시 및 방법 : Sales Opportunity 관리를 위해 CRM 시스템에 고객정보 등록 시 네트워크를 통한 전송
                        </li>
                        <li>
                        이전되는 개인정보 항목
                        <br>고객의 이름, 생년월일, 이메일, 전화번호, 휴대전화 번호, 사업자번호, 주소
                        </li>
                        <li>
                        개인정보를 이전받는 자의 이용목적 및 보유∙이용 기간
                        <br>개인정보 보유기간 동안 개인정보를 이전받는 자가 운영하는 해외 데이터 센터에 개인정보를 저장, 보관, 관리
                        </li>
                        <li>
                        동의를 거부할 권리 및 동의 거부에 따른 불이익
                        <br>정보주체는 정보 수집을 거부할 권리가 있습니다. 단, 동의를 거부할 경우 서비스가 제한될 수 있습니다.
                        </li>
                        </ul>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">11. 개인정보의 안전성 확보 조치</div>
                    <p>회사는 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출 변조 또는 훼손되지 않도록 아래와 같은 안전성 확보 조치를 취하고 있습니다.</p>
                    <div class="trem_under_t">
                        <h4>[기술적 조치]</h4>
                        <p></p>
                        <ul>
                        <li>개인정보의 안전한 저장 및 전송 등을 위하여 법령이 정한 기준을 준수하고 있습니다.</li>
                        <li>회사는 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다.</li>
                        <li>백신프로그램은 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[관리적 조치]</h4>
                        <p></p>
                        <ul>
                        <li>회사는 정보주체를 직접 상대로 하여 영업 및 마케팅 업무를 수행하는 자, 개인정보관리업무를 수행하는 자, 기타 업무상 개인정보의 취급이 불가피한 자 등으로 개인정보에 대한 접근권한을 제한하고 있습니다.</li>
                        <li>개인정보를 취급하는 직원을 대상으로 개인정보보호에 관한 정기적인 사내 교육 및 외부 위탁교육을 실시하고 있으며, 입사 및 퇴사 후 개인정보보호에 관한 법령을 준수하도록 철저히 관리∙감독하고 있습니다.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[물리적 조치]</h4>
                        <p></p>
                        <ul>
                        <li>개인정보와 개인정보처리시스템의 안전한 보관을 위하여 물리적 잠금장치 등의 물리적 접근방지를 위한 보호조치를 취하고 있습니다.</li>
                        <li>전산실 및 자료 보관실 등을 특별 보호구역으로 설정하여 출입을 통제하고 있습니다.</li>
                        </ul>
                    </div>
                </div>
            </div>
            
            

            <div class="term_wrap" v-else>
                <p>We at HD HYUNDAI INFRACORE Co., Ltd. (hereafter: “we,” “us,” “our”) comply with the personal information protection clauses of the relevant laws, including the Personal Information Protection Act and the Act on the Promotion of Information and Communications Network Utilization and Information Protection, etc. We also do everything we can to protect the rights and interests of data subjects including our customers, employees, homepage users, etc. in accordance with the Personal Information Handling Guidelines (“the GUIDELINES”) that we have established under the relevant law.</p>
                <p>We make it a rule to inform all data subjects of the items of personal information that we collect from them, the purpose of such collection, and the steps we take to protect their personal information according to the GUIDELINES. In the event of a revision of the GUIDELINES, we will put up a public notice on our website or inform each individual data subject thereof.</p>
                <p>Effective date: September 1, 2020</p>
                <div class="term_box">
                    <div class="term_title">1. General Provisions</div>
                    <p>
                    “Personal information” refers to the name, resident registration number, video image etc. included in the information on a living individual, which is used to identify that individual (including information that can only be used to identify an individual in combination with other information).<br/>
                    “Data subject” refers to a person who, as the subject of the collected information, can be identified with the processed information. We display the GUIDELINES on the first screen of our homepage (<a href="https://gsis.hd-infracore.com" target="_blank">gsis.hd-infracore.com</a>) to allow users to consult them easily at any time.
                    </p>
                </div>
                <div class="term_box">
                    <div class="term_title">2. Purpose of processing personal information</div>
                    <p>We process personal information for the following purposes.</p>
                    <div class="trem_under_t">
                        <h4>[Concerning services provided by us]</h4>
                        <p></p>
                        <ul>
                        <li>Membership management; processing of users’ complaints/opinions.</li>
                        <li>Online market surveys and opinion polls.</li>
                        <li>Marketing or ads.</li>
                        <li>Service provision and settlement of fees.</li>
                        <li>Support for subcontractors.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[Concerning the recruitment of employees]</h4>
                        <p></p>
                        <ul>
                        <li>Screening of recruitment applications, correction of application forms, checking of results of application, contacts with applicants, checking of application requirements.</li>
                        <li>Salary payment, welfare-related matters, support provided to employees in their execution of business, and personnel management including evaluations.</li>
                        </ul>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">3. Period of processing/retention of personal information</div>
                    <p>We destroy personal information upon attaining the purpose of its collection/use. However, we keep the following personal information for the period stated in the following.</p>
                    <div class="trem_under_t">
                        <h4>[Concerning services provided by us]</h4>
                        <ul>
                        <li>Personal information items kept: name, home address, email, contact number, name of company, name of representative, type of business, bank account information, service use records, connection log, cookies, and connection IP information.</li>
                        <li>Period of retention: Until the end of the service provided, or what is separately stipulated in the law if that is the case.</li>
                        <li>Reason for retention: user identification, improvement of service quality, and provision of support for subcontractors’ business.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[Concerning recruitment and maintenance of recruitment status]</h4>
                        <ul>
                        <li>Personal information items kept: name, password, DOB, gender, resident registration number, home address, home phone number, cell phone number, interests, special skills, academic background, work experience, foreign language proficiency, military service record, family-related matters.</li>
                        <li>Period of retention: Until the end of employment or an extended period pursuant to consent by the data subjects.</li>
                        <li>Reason for retention: Salary payment, welfare-related matters, support provided to employees in their execution of business, and personnel management including evaluations.</li>
                        </ul>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">4. Methods of destruction of personal information</div>
                    <p>We destroy personal information upon attaining the purpose of its collection/use, termination of the service, or end of the relevant business.</p>
                    <div class="trem_under_t">
                        <div class="t_u_inner">
                            <h5>A. Destruction procedure</h5>
                            <p>We destroy personal information and personal information files that we no longer needs according to our internal guidelines and procedure, as follows</p>
                            <ul>
                                <li>Destruction of personal information: Upon expiry of the designated period of retention.</li>
                                <li>Destruction of personal information files: On the day the file is judged to be no longer needed as the purpose of its collection/use has been attained, or upon termination of the service, etc.</li>
                            </ul>
                        </div>
                        <div class="t_u_inner">
                            <h5>B. Destruction method</h5>
                            <ul>
                                <li>For personal information stored in electronic files – Destruction in a way that renders such information irretrievable.</li>
                                <li>For printouts containing personal information – Shredded or incinerated.</li>
                            </ul>
                        </div>                        
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">5. Provision of personal information to third parties</div>
                    <p>We do not provide any personal information to any third party without a justifiable reason, such as being required to do so by the law, or without the prior consent of the data subject, etc., unless one of the following is the case:</p>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>In cases where the data subject’s separate consent has been obtained.</li>
                        <li>In cases where a special clause is stipulated in the law.</li>
                        <li>In cases where it is judged that such provision is clearly required to protect the life or property of the data subject or the third party, and where the data subject or his legal agent is unable to express his opinion or it is impossible to obtain his/her consent due to the lack of an address etc.</li>
                        <li>In cases where personal information is provided in such a way that specific individuals cannot be identified for the purpose of drawing up statistics or for academic research.</li>
                        </ul>
                    </div>
                    <p>Currently, we provide personal information to third parties as follows:</p>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Parties to which we provide personal information: Multicampus, Korea TOEIC Committee, Korea Chamber of Commerce and Industry.</li>
                        <li>Personal information items provided: name, DOB, cell phone number.</li>
                        <li>Purpose of use of personal information: Verification of qualifications for recruitment.</li>
                        <li>Period of retention/use of personal information provided: Until attainment of the purpose of collection/use.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Parties to which we provide personal information: Ministry of Defense/local offices of the Military Manpower Administration, district offices/community service centers.</li>
                        <li>Personal information items provided: name, resident registration number, cell phone number, military serial number.</li>
                        <li>Purpose of use of personal information: Conduct of business related to the Homeland Reserve Forces, such as the organization, mobilization, training or demobilization of HR Forces.</li>
                        <li>Period of retention/use of personal information provided: Until the end of the employment.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Parties to which we provide personal information: HD HYUNDAI INFRACORE Corporation.</li>
                        <li>Personal information items provided: name, photo, password, home address, home phone number, cell phone number, email, academic background, military service record, foreign language proficiency, computer skill, qualifications, familial relations, work experience, social experience, prizes received, experience accumulated overseas, research experience.</li>
                        <li>Purpose of use of personal information: Management/development of human resources.</li>
                        <li>Period of retention/use of personal information provided: Until the end of employment.</li>
                        </ul>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">6. Entrustment of personal information processing</div>
                    <p>We do not entrust the processing of personal information to a third party without obtaining the prior consent of the data subject. We entrust personal information as follows and ensure that all entrustment contracts include a clause on the safe management of the information under the law.</p>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Trustee: Hyundai C&R</li>
                        <li>Content of entrustment: Matters pertaining to salary management, welfare, and general affairs (e.g. management of company vehicles/cell phones, mutual aid, etc.).</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Trustees: Multicampus, KACNET, ALPACO, SPICUS, PICKUPPHONE, eCAMPUS, KT Innoedu.</li>
                        <li>Content of entrustment: Matters pertaining to Internet-based lectures for employees, etc.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Trustee: HD HYUNDAI INFRACORE Digital Innovation</li>
                        <li>Content of entrustment: Operation and management of the personnel information processing system.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Trustee: International SOS Korea</li>
                        <li>Content of entrustment: Operation of a positioning system in linkage with employees undertaking overseas business trips.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Trustee: S1</li>
                        <li>Content of entrustment: Photo-taking; issuance of employee passes.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Trustee : KUMA DATA TECH</li>
                        <li>Content of entrustment: Issuance of employee IDs.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Trustee : Photomind</li>
                        <li>Content of entrustment: Taking photos of employees.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Trustee : Oracle Corporation</li>
                        <li>Content of entrustment: Retention/management of personal information.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Trustee : Salesforce.com Singapore Pte Ltd</li>
                        <li>Content of entrustment: Retention/management of personal information.</li>
                        </ul>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">7. Data subjects’ rights and obligations and how to exercise them</div>
                    <p>Data subjects may ask us to allow them to access, correct or delete their personal information or request that we cease our handling and processing thereof. However, we may reject or restrict such request in any of the following cases.</p>
                    <div class="trem_under_t">
                        <h4></h4>
                        <ul>
                        <li>Where there is a special clause in the law; in cases where we are required to fulfill our legal obligation.</li>
                        <li>In cases where it is feared that compliance with such request will cause harm to a person’s life or health or unjustly infringe on a person’s interests, including their property.</li>
                        <li>In cases where failure not to handle personal information makes it impossible to execute a contract, including the provision of a service stipulated in a contract to a data subject, and where the data subject has failed to clearly express his/her intention to terminate the contract.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>Methods and procedure of exercising rights</h4>
                        <ul>
                        <li>Data subjects who wish to access their personal information kept by us may submit a request for access to, correction/deletion of, or cessation of our handling of their information to our department in charge of personal information in writing by email or fax, etc. (For information on the department, refer to 08. Service for handling petitions about personal information hereto.)</li>
                        <li>With regard to the submittal of such request, we will comply with it within 10 days unless there is a justifiable reason for not doing so, or inform the data subject of the reason for our restriction/refusal within 5 days and how the data subject may file an appeal for our reconsideration of the matter.</li>
                        <li>Where data subjects or their agents request access to the personal information kept by us, we may check their identity by asking for their ID (e.g. resident registration card) or certified electronic signature, etc.</li>
                        </ul>
                    </div>                    
                </div>
                <div class="term_box">
                    <div class="term_title">8. Our personal information service</div>
                    <p>We have appointed a department and a Personal Information Manager as following to handle all business concerning the protection of users’ personal information and associated complaints.</p>
                    <div class="trem_under_t">
                        <div class="t_u_inner">
                            <h5>A. Department in charge of personal information</h5>
                            <p></p>
                            <ul>
                                <li>Name of department: Security Audit Team</li>
                                <li>Telephone number: 031-5179-4146, 4144</li>
                                <li>Fax No.: 031-5179-4198</li>
                                <li>E-mail: <a href="mailto:di_security@hyundai-di.com">di_security@hyundai-di.com</a></li>
                                <li>Hours: (Mon. – Fri.) 09:00 – 18:00 on weekdays</li>
                            </ul>
                        </div>
                        <div class="t_u_inner">
                            <h5>B. Personal Information Manager</h5>
                            <p></p>
                            <ul>
                                <li>Name: Mr. PARK Dongbeom, Managing Director</li>
                                <li>Telephone number: 031-5179-4146</li>
                                <li>E-mail: <a href="mailto:di_security@hyundai-di.com">di_security@hyundai-di.com</a></li>
                            </ul>
                        </div> 
                        <div class="t_u_inner">
                            <h5></h5>
                            <p>If you need to report a case of personal information infringement or wish to receive consulting, please contact one of the following:</p>
                            <ul>
                                <li>Personal Information Dispute Mediation Committee (<a href="http://privacy.kisa.or.kr" target="_blank">http://privacy.kisa.or.kr</a> Telephone number: 118)</li>
                                <li>Personal Information Infringement Report Center (<a href="http://www.privacy.go.kr" target="_blank">http://www.privacy.go.kr</a> Telephone number: 118)</li>
                                <li>Information Protection Mark Certification Committee (<a href="http://www.eprivacy.or.kr" target="_blank">http://www.eprivacy.or.kr</a> Telephone number: 02-580-0533~4)</li>
                                <li>Internet Crime Investigation Center of the Supreme Prosecutors' Office (<a href="http://www.spo.go.kr" target="_blank">http://www.spo.go.kr</a> Telephone number: 02-3480-3600)</li>
                                <li>National Police Agency Cyber Terror Response Center (<a href="http://www.ctrc.go.kr" target="_blank">http://www.ctrc.go.kr</a> Telephone number: 02-392-0330)</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">9. Installation/operation of devices for automatic collection of personal information and customers’ refusal thereof</div>
                    <p>We use “cookies” to store users’ information and fetch it from time to time. Cookies are very small text files stored in your computer hard disk. They are sent by the server used to operate our website to users’ browser. We use cookies for the following purpose.</p>
                    <div class="trem_under_t">
                        <div class="t_u_inner">
                            <h5>A. Purpose of use of cookies</h5>
                            <p>Cookies are used to analyze the frequency of users’ connection to a website or the time of day of their visits, to determine users’ tastes/interests, to check the level of their participation in special events, etc., which are necessary for our targeted marketing and the provision of customized services to users. You have the right to accept or reject our installation of cookies in your computer hard disk by setting the option in your web browser. You may accept all cookies, check each time cookies are stored, or reject all cookies.</p>
                        </div>
                        <div class="t_u_inner">
                            <h5>2. How to reject the installation of cookies</h5>
                            <p>
                                You may accept all cookies, check each time cookies are stored, or reject all cookies by setting the option of your web browser accordingly. How to set the option (in Internet Explore) : Go to “Tool” at the top of your web browser > Internet option
                                <br>&gt; personal information. You may have difficulty in using our services if you refuse to accept cookies.
                            </p>
                        </div>                        
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">10. Overseas transfer of personal information</div>
                    <p>We transfer data subjects’ personal information to third parties abroad as follows in the process of handling our business through the following system. This allows us to handle the information in a server in an area outside the country in which the data subject resides.</p>
                    <div class="trem_under_t">
                        <h4>[Access Portal]</h4>
                        <p></p>
                        <ul>
                        <li>
                        Business to which we transfer personal information and contact point
                        <br>Name of business: Oracle Corporation
                        <br>Contact point: <a href="https://www.oracle.com/corporate/contact/" target="_blank">https://www.oracle.com/corporate/contact/</a> (Telephone number: +1.650.506.7000)
                        </li>
                        <li>
                        Country where the transferee is located, date, method.
                        <br>Country where the transferee is located: Ashburn, Virginia, U.S.A.
                        <br>Date and method: Transmission via the network with the request for issuance of an account through the Access Portal.
                        </li>
                        <li>
                        Personal information items transferred
                        <br>User’s name, User ID, nationality, email, home phone number, cell phone number, position in workplace.
                        </li>
                        <li>
                        Purpose of personal information transfer; Period of retention/use of personal information
                        <br>Storage, retention, and management at an overseas data center operated by the transferee during the relevant period.
                        </li>
                        <li>Data subjects have the right to reject the collection of their personal information, but such refusal may lead to restrictions on their use of our service.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[CRM]</h4>
                        <p></p>
                        <ul>
                        <li>
                        Business to which we transfer personal information and contact point
                        <br>Name of business: Salesforce.com Singapore Pte. Ltd.
                        <br>Contact point : <a href="https://www.salesforce.com/form/other/privacy-request" target="_blank">https://www.salesforce.com/form/other/privacy-request</a>
                        </li>
                        <li>
                        Country where the transferee is located, date, method.
                        <br>Area where the transferee is located: Tokyo, Japan
                        <br>Date and method: Transmission via the network with the registration of customer information with the CRM system for sales opportunity management.
                        </li>
                        <li>
                        Personal information items transferred:
                        <br>Customer’s name, DOB, email, home phone number, cell phone number, business registration number, address.
                        </li>
                        <li>
                        Purpose of personal information transfer; Period of retention/use of personal information
                        <br>Storage, retention, and management at an overseas data center operated by the transferee during the relevant period.
                        </li>
                        <li>Data subjects have the right to reject the collection of their personal information, but such refusal may lead to restrictions on their use of our service.</li>
                        </ul>
                    </div>
                </div>
                <div class="term_box">
                    <div class="term_title">11. Steps taken to secure the safety of personal information</div>
                    <p>We take the following steps to secure safety when handling users’ personal information to prevent the loss, theft, leakage, forgery or damage thereof.</p>
                    <div class="trem_under_t">
                        <h4>[Technical steps]</h4>
                        <p></p>
                        <ul>
                        <li>We observe the criteria stipulated in the law for the safe storage and transmission of personal information.</li>
                        <li>We use vaccine programs to protect our users’ personal information against damages caused by computer viruses.</li>
                        <li>The vaccine programs are updated periodically. We immediately use newly developed vaccine programs to prevent the personal information kept by us from being affected.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[Administrative steps]</h4>
                        <p></p>
                        <ul>
                        <li>We restrict the right to access personal information to the following employees: those responsible for sales/marketing with data subjects first hand; those responsible for the managing personal information; those responsible for handling personal information as a regular part of their duties.</li>
                        <li>We run periodic in-house education sessions concerning personal information protection for employees who are responsible for handling personal information, including the appointment of outside lecturers. We do all we can to ensure that our employees observe the laws concerning personal information protection both during their employment and after their retirement.</li>
                        </ul>
                    </div>
                    <div class="trem_under_t">
                        <h4>[Physical steps]</h4>
                        <p></p>
                        <ul>
                        <li>We take protective measures such as the use of physical locks to prevent physical access in order to keep personal information and the personal information processing system safe.</li>
                        <li>We have designated our computer rooms and rooms for storing important information as off-limits areas to ensure the protection of users’ personal information.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
	</section>
  </div>
</template>

<script>
export default {
mounted(){
   this.$root.$emit("initMenuClassActive");
},
}
</script>

<style>

</style>